export const MAX_NUMBER_OF_LATE_RECEIPTS = 100_000;
export const MIN_NUMBER_OF_LATE_RECEIPTS = 1;
